import type { DragType } from "../engines/interactionEngine/interactionObserverConstants";
import type { CustomPointerEvent } from "../engines/interactionEngine/interactionTypes";
import { renderFlags } from "../engines/layoutEngine/renderFlags";

export function handleOnDropping({
  event,
  key,
  dropType
}: {
  event: CustomPointerEvent;
  key: string;
  dropType: DragType;
}): boolean {
  const { dragContextStore } = event;
  if (dragContextStore) {
    if (dragContextStore.sourceId === key) {
      // Can't be dropping on itself
      return false;
    }
    if (
      dragContextStore.droppingOverId !== key &&
      dragContextStore.droppingOverType !== dropType
    ) {
      dragContextStore.droppingOverId = key;
      dragContextStore.droppingOverType = dropType;
      // Set the dirty flag to true to trigger a re-render
      renderFlags.domDirty = true;
    }
    // Return true to indicate that the event was handled
    return true;
  }
  return false;
}

export function handleOnDroppingOut({
  event,
  key
}: {
  event: CustomPointerEvent;
  key: string;
}) {
  const { dragContextStore } = event;
  if (dragContextStore && dragContextStore.droppingOverId === key) {
    dragContextStore.droppingOverId = undefined;
    dragContextStore.droppingOverType = undefined;
    // Set the dirty flag to true to trigger a re-render
    renderFlags.domDirty = true;
    // Return true to indicate that the event was handled
    return true;
  }
  // Something else was getting "dropped over" so it's best to let that node
  // handle dropping out as well.
  return false;
}

export function handleOnDrop({ event }: { event: CustomPointerEvent }) {
  const { dragContextStore } = event;
  if (dragContextStore) {
    dragContextStore.droppingOverId = undefined;
    dragContextStore.droppingOverType = undefined;
    renderFlags.domDirty = true;
  }
}

export function handleDragStart({
  event,
  sourceId,
  sourceParentId,
  sourceIndex,
  sourceDragType
}: {
  event: CustomPointerEvent;
  sourceId: string;
  sourceParentId: string;
  sourceIndex: number;
  sourceDragType: DragType;
}) {
  const { dragContextStore } = event;
  if (dragContextStore) {
    dragContextStore.sourceId = sourceId;
    dragContextStore.sourceParentId = sourceParentId;
    dragContextStore.sourceIndex = sourceIndex;
    dragContextStore.dragType = sourceDragType;
  }
}
